































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import { FeedbackType, FeedbackTypes } from '@/modules/feedbacks/domain/feedback-types';
import { feedbacks, layout } from '@/modules/shared/shared/store/namespaces';
import { FeedbacksActions } from '@/modules/feedbacks/store/feedbacks.actions';
import { FeedbacksGetters } from '@/modules/feedbacks/store/feedbacks.getters';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { FeedbacksResults } from '@/modules/feedbacks/domain/feedbacks-results';
import { FeedbackComment } from '@/modules/feedbacks/domain/feedback-comment';
import { FeedbackCount } from '../domain/feedback-count';

@Component({})
export default class FeedbackDashboard extends Vue {
    feedbacksPage: number = 1;
    suggestionsPage: number = 1;
    typeSelected: number | null = null;
    noFeedbacks: boolean = false;
    FEEDBACK_TYPE_SUGESTION = 3;

    async mounted() {
        this.changeTitle({ title: 'Gestión', route: ['FEEDBACKS'] });

        const feedbacksFailed = await this.fetchFeedbacks({
            limit: 5,
            start: 1,
            type: null!,
        });

        if (feedbacksFailed) {
            (feedbacksFailed as ExceptionMessage).showError();
        }

        const suggestionsFailed = await this.fetchSuggestions({
            limit: 5,
            start: 1,
        });

        if (suggestionsFailed) {
            (suggestionsFailed as ExceptionMessage).showError();
        }
    }

    setFormatDate(fullDate: string, fromNow: boolean = true) {
        let formattedDate: string;

        if (fromNow) {
            formattedDate = moment(fullDate)
                .locale('es')
                .fromNow();
        } else {
            formattedDate = moment(fullDate).format('DD/MM/YYYY hh:mm a');
        }

        return formattedDate;
    }

    get total() {
        let total: number = 0;

        if (this.feedbackCards) {
            total = this.feedbackCards.reduce(function(total, card) {
                return total + Number(card.total);
            }, 0);
        }

        return total;
    }

    async changeFeedbacksType(typeId: number) {
        this.typeSelected = typeId;
        this.feedbacksPage = 1;

        const failed = await this.fetchFeedbacks({
            limit: 5,
            start: this.feedbacksPage,
            rating: typeId,
        });

        if (failed) {
            (failed as ExceptionMessage).showError();
        }
    }

    async changeFeedbacksPage() {
        const failed = await this.fetchFeedbacks({
            limit: 5,
            start: this.feedbacksPage,
            rating: this.typeSelected!,
        });

        if (failed) {
            (failed as ExceptionMessage).showError();
        }
    }

    async changeSuggestionsPage() {
        const failed = await this.fetchSuggestions({
            limit: 5,
            start: this.suggestionsPage,
        });

        if (failed) {
            (failed as ExceptionMessage).showError();
        }
    }

    getFeedbackTypes(): FeedbackType[] {
        return Object.keys(FeedbackTypes).map(types => {
            return FeedbackTypes[types];
        });
    }

    getFeedbackType(id: number): FeedbackType {
        const defaultFeedbackType: FeedbackType = {
            id: -1,
            name: 'generic',
            cssClass: 'feedbacks',
            icon: 'mdi-message-text-outline',
            color: '#00395c',
        };

        const feedbackType: FeedbackType | undefined = this.getFeedbackTypes().find(
            feedbackType => feedbackType.id === id,
        );

        return feedbackType ? feedbackType : defaultFeedbackType;
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE) changeTitle!: (title: LayoutTitle) => void;

    @feedbacks.Action(FeedbacksActions.FETCH_FEEDBACKS) fetchFeedbacks!: (options: {
        limit: number;
        start: number;
        type?: number;
        rating?: number;
    }) => Promise<RequestResponse>;

    @feedbacks.Action(FeedbacksActions.FETCH_SUGGESTIONS) fetchSuggestions!: (options: {
        limit: number;
        start: number;
    }) => Promise<RequestResponse>;

    @feedbacks.Getter(FeedbacksGetters.GET_FEEDBACK_CARDS)
    feedbackCards!: FeedbackCount[];

    @feedbacks.Getter(FeedbacksGetters.GET_ALL_FEEDBACKS)
    allFeedbacks!: FeedbacksResults;

    @feedbacks.Getter(FeedbacksGetters.GET_FEEDBACK_AVERAGE)
    average!: number;

    @feedbacks.Getter(FeedbacksGetters.GET_ALL_COMMENTS)
    comments!: FeedbackComment[];

    @feedbacks.Getter(FeedbacksGetters.GET_MONTH_SUGGESTIONS)
    monthSuggestions!: FeedbacksResults;

    @feedbacks.Getter(FeedbacksGetters.GET_SUGGESTIONS)
    suggestions!: FeedbackComment[];
}
